module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/relayevent/font/notokr-bold.woff
// module id = U3p6
// module chunks = 0